<template>
  <el-dialog :title="title" :visible.sync="Visible" width="95vw" top="2vw" center class="ac-dialog"
    :close-on-click-modal="false" @close="close">
    <el-form :inline="true" :model="form" class="demo-form-inline" label-width="120px" label-position="right">
      <el-row :gutter="24">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="标题">
            <el-input v-model="form.name" style="width: 315px" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="视频分类ID">
            <el-input v-model="form.cat_id" style="width: 315px" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="视频分类名称">
            <el-input v-model="form.cat_name" style="width: 315px" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="视频描述">
            <el-input v-model="form.description" style="width: 315px" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="视频导演">
            <el-input v-model="form.director" style="width: 315px" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="视频语言">
            <el-input v-model="form.language" style="width: 315px" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="视频系列">
            <el-input v-model="form.series" style="width: 315px" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="封面类型">
            <el-select style="width: 180px" placeholder="请选择封面类型" v-model="form.img_type">
              <el-option :key="item.value" :label="item.label" :value="item.value" v-for="item in coverTypeList" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="横版封面">
            <decrypt-img style="width: 330px; height: 150px; margin: 0 auto" :noNeedDoamin="true"
              :src="form.img_x"></decrypt-img>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="竖版封面">
            <decrypt-img style="width: 120px; height: 300px; margin: 0 auto" :noNeedDoamin="true"
              :src="form.img_y"></decrypt-img>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="预览图片">
            <decrypt-img style="width: 300px; height: 300px; margin: 0 auto" :noNeedDoamin="true"
              :src="form.preview_images"></decrypt-img>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="是否多集">
            <el-switch v-model="form.is_more_link" active-color="#13ce66" inactive-color="#ff4949"
              style="width: 180px"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="上架状态">
            <el-switch v-model="form.status" active-color="#13ce66" inactive-color="#ff4949"
              style="width: 180px"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="更新状态">
            <el-switch v-model="form.update_status" active-color="#13ce66" inactive-color="#ff4949"
              style="width: 180px"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="标签">
            <el-tag :key="index + 'tagData'" style="margin: 2px" v-for="(item, index) in form.tags" size="mini">
              {{ item.name }}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="采集网站标签">
            <el-tag :key="index + 'tagData'" style="margin: 2px" v-for="(item, index) in form.source_tags" size="mini">
              {{ item }}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8">
          <el-form-item label="上传时间">
            <el-date-picker style="width: 180px" v-model="form.issue_date" type="date" placeholder="选择日期"
              value-format="yyyy-MM-ddTHH:mm:ssZ">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8">
          <el-form-item label="上架时间">
            <el-date-picker style="width: 180px" v-model="form.show_at" type="date" placeholder="选择日期"
              value-format="yyyy-MM-ddTHH:mm:ssZ">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <div style="display: flex;">
      <div style="margin-right: 100px;">
        <h3>预览</h3>
        <div style="width: 380px; height: 240px; overflow: hidden">
          <DPlayer ref="player" v-if="form.links[0].preview_m3u8_url.indexOf('mp4') === -1" :video="{
            url: filterM3u8(form.links[0].preview_m3u8_url),
            type: 'hls',
            pic: '',
          }" hotkey></DPlayer>

        </div>
      </div>
      <div>
        <h3>正片</h3>
        <div v-if="form.links[0].m3u8_url" style="width: 380px; height: 240px; overflow: hidden">
          <DPlayer :video="{
            url: filterM3u8(form.links[0].m3u8_url),
            type: 'hls',
            pic: '',
          }" hotkey></DPlayer>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click.native.prevent="Visible = false"> 取 消 </el-button>

    </div>

  </el-dialog>
</template>
<script>
import DPlayer from '@/components/VueDplayerHls/index'
import 'videojs-contrib-hls'
import API from '@/api'


export default {
  name: 'AddOrEdit',
  props: ['data'],
  components: {
    DPlayer
  },

  data() {
    return {
      coverTypeList: [
        { label: '横版', value: 'long' },
        { label: '竖版', value: 'short' },
      ],

      type: undefined,
      videoType: undefined,
      innerVisible: false,
      Visible: true,
      title: '',

      taskId: '',
      tags: null,
      fieldNameFs: '', // 正片地址全称
      form: {
        links: [{
          m3u8_url: '',
          preview_m3u8_url: '',
        }]
      },

    }
  },

  async created() {
    this.title = this.data.title
    if (this.title === '查看详情') {
      await this.getVideoDetail()
      if (this.form.links.m3u8_url) {
        this.open()
      }
    }
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    getVideoDetail() {
      API.lsjVideoDetail({ id: this.data.data.id }).then((res) => {
        if (res.code === 200) {
          this.form = res.data
        } else {
          this.$message.error('请求失败!')
        }
      })
    },

    filterM3u8(v) {
      return /\.m3u8/g.test(v) ? v : v + '.m3u8'
    },
    // 清空某一项筛选列表
    onClear(key) {
      this.form.param[key] = []
    },

    // 上传图片返回地址
    changeCoverImgUrl(data) {
      this.form.coverImg = data
    },
    // / 监听视频播放的回调函数
    onPlayerPlay() { },
    // / 监听暂停播放的回调函数
    onPlayerPause() { },
    // / 监听当前视频数据加载完成
    onPlayerLoadeddata() { },
    // / 监听当前视频数据加载失败
    onPlayerError() { },
    // / 监听当前视频数据加载ing
    onPlayerWaiting() { },
    // / 监听当前视频播放完成
    onPlayerEnded() { },
    open() {
      this.mediaUrl =
        'api/web/media/m3u8/' +
        (this.form.links[0].m3u8_url.match(RegExp(/.m3u8/))
          ? this.form.links[0].m3u8_url
          : this.form.links[0].m3u8_url + '.m3u8')
      // this.$nextTick(function () {
      //   document.getElementById("media-box").innerHTML =
      //     '<video  id="my-video"  class="video-js vjs-default-skin"  controls preload="auto" style="width:100%;height:100%; "  playsinline="true"></video>';
      //   this.player = videojs("my-video", {
      //     bigPlayButton: false,
      //     textTrackDisplay: false,
      //     posterImage: true,
      //     errorDisplay: true,
      //     controlBar: true,
      //     playbackRates: [0.5, 1, 1.5, 2, 3, 5, 10],
      //   });
      //   this.player.src(this.mediaUrl);
      // });
    },

    // 关闭编辑
    close() {
      if (this.player) {
        this.player.dispose()
      }
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

.videoBox {
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.el-textarea.is-disabled.ti .el-textarea__inner {
  color: red;
}

.media-box {
  width: 100%;
  height: 400px;
  text-align: center;
  overflow: hidden;

  img {
    height: 100%;
    max-width: 100%;
  }

  #my-video {
    width: 100% !important;
    height: 100% !important;
    border: none !important;
  }
}

.check_upload {
  position: relative;
  padding: 10px;
  overflow: hidden;
  border: 1px dashed #ccc;
  background-color: #f5f5f5;

  div {
    display: inline-block;
    position: relative;
    padding: 4px 8px;
    font-size: 100%;
    line-height: 1.4;
    color: #666;
    border: 1px solid #666;
    cursor: pointer;
    border-radius: 2px;
    background: none;
    outline: none;
  }

}
</style>
